
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message } from "element-ui";

    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            keyword: '',
            status: '',
            sourceType: '0',
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };

        // 编辑
        toEdit(row: any) {
            api.post('A5004', {id: row.id}).then((res: any) => {
                this.ruleForm.id = res.id
                this.ruleForm.name = res.name
                this.ruleForm.type = res.type.toString()
                this.ruleForm.date1[0] = res.start_at
                this.ruleForm.date1[1] = res.end_at
                this.ruleForm.app_key = res.app_key
                this.ruleForm.config = res.config
                this.ruleForm.checkbox = res.checkbox
                this.addDialog = true
            })

        }

        // 修改状态
        choseStatus(id: any) {
            api.post('A5005', {id}).then(res => {
                this.$message.success('操作成功')
                this.searchTable()
            })
        }

        // 删除
        delDialog = false
        id = ''
        del(id: any) {
            api.getChannelProduct({id}).then(res => {
                this.id = id
                if(res.length > 0) {
                    this.delDialog = true
                    return
                }

                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.delA(id)
                })


            })

        }
        delA(id: any) {
            api.post('A5006', {id}).then(res => {
                this.$message.success('操作成功')
                this.searchTable()
            })
        }
        cancleDel() {
            this.delDialog = false
        }
        sureDel() {
            api.post('A5006', {id: this.id}).then(res => {
                this.$message.success('操作成功')
                this.delDialog = false
                this.searchTable()
            })

        }

        // 新建产品
        addDialog = false
        btnloading = false
        ruleForm: any = {
            name: '',
            type: '',
            date1: [],
            app_key: '',
            config: '',
            checkbox: 2
        }

        save() {
            if(!this.ruleForm.name) {
                this.$message.warning('请输入渠道名称')
                return
            }
            if(!this.ruleForm.type) {
                this.$message.warning('请选择渠道类型')
                return
            }
            if(this.ruleForm.date1.length == 0) {
                this.$message.warning('请选择有效期')
                return
            }
            this.btnloading = true;
            let obj: any = {
                name: this.ruleForm.name,
                type: this.ruleForm.type,
                start_at: this.ruleForm.date1[0],
                end_at: this.ruleForm.date1[1],
                app_key: this.ruleForm.app_key,
                config: this.ruleForm.config,
                checkbox: this.ruleForm.checkbox
            }
            if(this.ruleForm.id) {
                obj['id'] = this.ruleForm.id
            }
            api.post(this.ruleForm.id ? 'A5003' : 'A5002', obj).then(res => {
                this.$message.success('操作成功')
                this.addDialog = false
                this.searchTable()
            }).finally(() => {
                this.btnloading = false;
            })
        }
        cancle() {
            this.addDialog = false;
        }

        add() {
            this.ruleForm = {
                name: '',
                type: '',
                date1: [],
                app_key: '',
                config: '',
                checkbox: 2
            };
            this.addDialog = true
        }

        // 搜索 search:true 重置翻页
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A5001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        activated() {
            this.searchTable();
        }
    }
